import { render, staticRenderFns } from "./OpenRouterChannelDetail.vue?vue&type=template&id=8ddfa418&scoped=true"
import script from "./OpenRouterChannelDetail.vue?vue&type=script&lang=js"
export * from "./OpenRouterChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./OpenRouterChannelDetail.vue?vue&type=style&index=0&id=8ddfa418&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddfa418",
  null
  
)

export default component.exports